import { render, staticRenderFns } from "./scoreConfigView.vue?vue&type=template&id=12482126&scoped=true&"
import script from "./scoreConfigView.vue?vue&type=script&lang=js&"
export * from "./scoreConfigView.vue?vue&type=script&lang=js&"
import style0 from "./scoreConfigView.vue?vue&type=style&index=0&id=12482126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12482126",
  null
  
)

export default component.exports